import { render, staticRenderFns } from "./areacontrol.vue?vue&type=template&id=99acf50c&scoped=true&"
import script from "./areacontrol.vue?vue&type=script&lang=js&"
export * from "./areacontrol.vue?vue&type=script&lang=js&"
import style0 from "./areacontrol.vue?vue&type=style&index=0&id=99acf50c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99acf50c",
  null
  
)

export default component.exports